import { convertToJS } from "components/eventDivisions/helpers";
import { makeStyles } from "components/providers/makeStyles";
import { useEventDivision } from "components/routes/events/id/divisions/eventDivisionId/EventDivisionProvider";
import { DialogSectionLayout } from "../athlete/DialogSectionLayout";
import { TeamMembersList } from "./TeamMembersList";
import { AsyncAthleteSelectorField } from "components/layout/forms/fields/SelectorField";

const useStyles = makeStyles((theme) => ({
    section: {
        "&&": {
            marginTop: 0
        }
    }
}));

export const TeamMembers = ({ array, members, teamRoles }) => {
    const eventDivision = convertToJS(useEventDivision());
    const classes = useStyles();

    const membersToDisplay = members.reduce((map, member) => {
        if (member._destroy) return map;
        return {
            ...map,
            [member.order]: member.athlete ?
                { athlete: member.athlete, teamRoleName: member.team_role_name } :
                { athlete: { name: member.athlete_attributes.name }, teamRoleName: member.team_role_name } };
    }, {});

    const alreadyAdded = members.filter(member => member._destroy === undefined).map(member => member.athlete_id);
    const alreadyAssigned = members.filter(member => member._destroy === undefined).map(member => member.team_role_id);

    const onAthleteSelected = index => ({ label, value }) => {
        array.push("team_members_attributes", typeof value === "string"
            ? { athlete_attributes: { name: value }, order: index }
            : { athlete_id: value, athlete: { name: label }, order: index }
        );
    };

    const onUpdateTeamMemberRole = index => role => {
        const fieldIndex = members.findIndex(member => member.order === index);
        const member = members[fieldIndex];
        array.splice("team_members_attributes", fieldIndex, 1, { ...member, team_role_name: role && role.name, team_role_id: role && role.id });
    };

    const onAthleteRemoved = index => () => {
        const fieldIndex = members.findIndex(member => member.order === index);
        const member = members[fieldIndex];
        array.splice("team_members_attributes", fieldIndex, 1, member.id ? { ...member, _destroy: true } : null);
    };

    const renderTeamMembersSelector = index => <AsyncAthleteSelectorField alreadyAdded={alreadyAdded} onChange={onAthleteSelected(index)} />;

    return (
        <DialogSectionLayout title="Athletes" className={classes.section}>
            <TeamMembersList
                teamConfig={eventDivision.formatDefinition.teamConfig}
                members={membersToDisplay}
                onAthleteRemoved={onAthleteRemoved}
                renderTeamMembersSelector={renderTeamMembersSelector}
                teamRoles={teamRoles}
                onUpdateTeamMemberRole={onUpdateTeamMemberRole}
                assignedRoles={alreadyAssigned}
            />
        </DialogSectionLayout>
    );
};
